/* Nova newsletter popup: no external libraries and no AJAX interception of Shopify forms. */
(function () {
  'use strict';
  if (window.NovaNewsletter && typeof window.NovaNewsletter.init === 'function') {
    window.NovaNewsletter.init();
    return;
  }

  var CLOSED_KEY = 'nova-newsletter:closed-until:v1';
  var SUBSCRIBED_KEY = 'nova-newsletter:subscribed-until:v1';
  var PENDING_KEY = 'nova-newsletter:pending:v1';
  var DAY = 86400000;
  var controller = null;

  // Storage can be unavailable in private windows or embedded previews.
  function readStorage(type, key) {
    try { return window[type].getItem(key); } catch (error) { return null; }
  }
  function writeStorage(type, key, value) {
    try { window[type].setItem(key, String(value)); } catch (error) { /* Nonessential. */ }
  }
  function removeStorage(type, key) {
    try { window[type].removeItem(key); } catch (error) { /* Nonessential. */ }
  }

  function Newsletter(dialog) {
    this.dialog = dialog;
    this.form = dialog.querySelector('#NovaNewsletterForm');
    this.designMode = dialog.dataset.designMode === 'true';
    this.timer = null;
    this.previousFocus = null;
    this.completed = false;
    this.disposed = false;
    this.bind();
    this.start();
  }

  Newsletter.prototype.isBlocked = function () {
    var html = document.documentElement;
    return document.visibilityState === 'hidden' ||
      html.classList.contains('page-blocked') ||
      html.classList.contains('popup-shown') ||
      html.classList.contains('m6pn-open') ||
      !!document.querySelector('.popup-a.shown, .nv-drawer.is-open, .nv-search.is-open, dialog[open]:not(#NovaNewsletterPopup)');
  };

  Newsletter.prototype.isSuppressed = function () {
    if (this.dialog.dataset.mobileEnabled === 'false' && window.matchMedia('(max-width: 760px)').matches) return true;
    if (this.dialog.dataset.hideSubscribers === 'true' && (
      this.dialog.dataset.subscriber === 'true' ||
      Number(readStorage('localStorage', SUBSCRIBED_KEY)) > Date.now()
    )) return true;
    if (Number(readStorage('localStorage', CLOSED_KEY)) > Date.now()) return true;
    // Respect a dismissal made by the old theme during the current browser session.
    try {
      if (/(?:^|;\s*)has-newsletter=no(?:;|$)/.test(document.cookie)) return true;
    } catch (error) { /* Cookie access is not required. */ }
    return false;
  };

  Newsletter.prototype.schedule = function (delay, force) {
    var self = this;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(function attempt() {
      if (self.disposed || !self.dialog.isConnected || self.dialog.open) return;
      if (!force && self.isSuppressed()) return;
      // Never cover an age gate, cart, search drawer, another modal, or a background tab.
      if (self.isBlocked()) {
        self.timer = window.setTimeout(attempt, 500);
        return;
      }
      self.open(force);
    }, delay);
  };

  Newsletter.prototype.open = function (force) {
    if (this.disposed || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
    if (!force && this.isSuppressed()) return;
    if (this.isBlocked()) { this.schedule(500, force); return; }
    this.previousFocus = document.activeElement;
    this.dialog.showModal();
    document.documentElement.classList.add('nv-newsletter-open');
    this.dialog.querySelector('.nv-nl__scroll').scrollTop = 0;
    // Focus the heading/result, not the input: do not open a mobile keyboard automatically.
    var target = this.dialog.querySelector('[data-nv-result]:not([hidden])') || this.dialog.querySelector('#NovaNewsletterHeading');
    if (target) target.focus({ preventScroll: true });
  };

  Newsletter.prototype.close = function () {
    window.clearTimeout(this.timer);
    if (this.dialog.open) this.dialog.close();
  };

  Newsletter.prototype.bind = function () {
    var self = this;
    var pointerStartedOutside = false;
    this.dialog.querySelector('[data-nv-close]').addEventListener('click', function () { self.close(); });
    // The native dialog emits cancel on Escape and provides focus containment / page inertness.
    this.dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      self.close();
    });
    // Keep Tab cycling inside the popup instead of moving to browser chrome.
    this.dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
        self.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(self.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ), function (element) { return element.getClientRects().length > 0 && element.tabIndex >= 0; });
      if (!focusable.length) {
        event.preventDefault();
        self.dialog.querySelector('#NovaNewsletterHeading').focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || active.id === 'NovaNewsletterHeading')) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });
    this.dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('nv-newsletter-open');
      if (!self.designMode && !self.disposed) {
        var days = Math.max(1, Math.min(30, Number(self.dialog.dataset.repeatDays) || 7));
        writeStorage('localStorage', CLOSED_KEY, Date.now() + days * DAY);
      }
      if (self.previousFocus && self.previousFocus.isConnected && !self.dialog.contains(self.previousFocus)) {
        self.previousFocus.focus({ preventScroll: true });
      }
    });
    function outside(event) {
      var rect = self.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    this.dialog.addEventListener('pointerdown', function (event) {
      pointerStartedOutside = event.target === self.dialog && outside(event);
    });
    this.dialog.addEventListener('click', function (event) {
      if (pointerStartedOutside && event.target === self.dialog && outside(event)) self.close();
      pointerStartedOutside = false;
    });
    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        // Browsers run required/email/checkbox validation before dispatching submit.
        if (self.designMode) {
          event.preventDefault();
          var notice = self.form.querySelector('[data-nv-editor-notice]');
          if (!notice) {
            notice = document.createElement('p');
            notice.className = 'nv-nl__result';
            notice.setAttribute('data-nv-editor-notice', '');
            notice.setAttribute('role', 'status');
            self.form.appendChild(notice);
          }
          notice.textContent = 'Editor preview only. Test email signup in the storefront preview.';
          return;
        }
        writeStorage('sessionStorage', PENDING_KEY, Date.now());
        // Do not preventDefault, call fetch, or mark success here. Shopify handles the POST,
        // duplicate addresses, double opt-in settings, and spam/CAPTCHA challenges.
      });
      this.form.addEventListener('input', function (event) {
        if (event.target.id === 'NovaNewsletterEmail') event.target.removeAttribute('aria-invalid');
      });
    }
  };

  Newsletter.prototype.start = function () {
    var result = this.dialog.querySelector('[data-nv-result]');
    var pending = Number(readStorage('sessionStorage', PENDING_KEY));
    var recentSubmission = pending > 0 && Date.now() - pending < 10 * 60 * 1000;
    var ownAnchor = window.location.hash === '#NovaNewsletterForm';
    // Customer-form state is shared by some Shopify newsletter forms. Only reopen for this one.
    if (result && (recentSubmission || ownAnchor)) {
      result.hidden = false;
      removeStorage('sessionStorage', PENDING_KEY);
      if (result.dataset.nvResult === 'success') {
        this.completed = true;
        var fields = this.dialog.querySelector('[data-nv-form-fields]');
        if (fields) fields.hidden = true;
        if (!this.designMode) writeStorage('localStorage', SUBSCRIBED_KEY, Date.now() + 365 * DAY);
      }
      this.schedule(120, true);
      return;
    }
    if (pending && !recentSubmission) removeStorage('sessionStorage', PENDING_KEY);
    // A successful footer newsletter signup is also a known subscription. Do not
    // immediately ask that visitor to sign up again or show this popup's success UI.
    if (result && result.dataset.nvResult === 'success' && !this.designMode) {
      writeStorage('localStorage', SUBSCRIBED_KEY, Date.now() + 365 * DAY);
      if (this.dialog.dataset.hideSubscribers === 'true') return;
    }
    // Clear foreign-form error state on this input; keep foreign results hidden.
    if (result && !recentSubmission && !ownAnchor) {
      var email = this.dialog.querySelector('#NovaNewsletterEmail');
      if (email) {
        email.removeAttribute('aria-invalid');
        email.removeAttribute('aria-describedby');
      }
    }
    if (this.designMode) {
      if (this.dialog.dataset.editorPreview === 'true') this.schedule(300, true);
    } else if (window.location.pathname.indexOf('/challenge') === -1) {
      this.schedule(Math.max(0, Number(this.dialog.dataset.delay) || 0), false);
    }
  };

  Newsletter.prototype.destroy = function () {
    this.disposed = true;
    window.clearTimeout(this.timer);
    if (this.dialog.open) this.dialog.close();
    document.documentElement.classList.remove('nv-newsletter-open');
  };

  function init() {
    var dialog = document.querySelector('[data-nv-newsletter]');
    if (controller && controller.dialog === dialog && dialog.isConnected) return;
    if (controller) { controller.destroy(); controller = null; }
    if (dialog) controller = new Newsletter(dialog);
  }

  // Capture legacy links before the original theme's popup handler can handle them.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[data-nv-newsletter-preview], [data-nv-newsletter-open], a[data-popup="newsletter-popup"], a[href="#newsletter-popup"]');
    if (!trigger) return;
    init();
    if (!controller) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    controller.open(true);
  }, true);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { window.setTimeout(init, 0); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) init();
  });
  window.NovaNewsletter = {
    init: init,
    open: function () { init(); if (controller) controller.open(true); },
    close: function () { if (controller) controller.close(); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
